export interface Company {
  id: string;
  name: string;
  taxId: string;
  vatId?: string;
  country?: string;
  city?: string;
  address?: string;
  phone?: string;
  email?: string;
  website?: string;
  logoPath?: string;
  ownerId: string;
  ownerEmail: string;
  bankAccounts: BankAccount[];
  createdAt: string;
  updatedAt: string;
}

export enum InvoiceNumberingTemplate {
  NN_MM_YYYY = 'NN_MM_YYYY',
  NN_YYYY = 'NN_YYYY',
  NN_MM_YYYY_ID = 'NN_MM_YYYY_ID'
}

export interface InvoiceNumberingSettings {
  template: InvoiceNumberingTemplate;
  currentSequence: number;
  suffix?: string;
}

export interface InvoiceNumberingSettingsRequest {
  template: InvoiceNumberingTemplate;
  suffix?: string;
  currentSequence?: number;
}

export interface BankAccount {
  id: string;
  name: string;
  accountNumber: string;
  bankName: string;
  swift?: string;
  iban?: string;
  correspondentAccount?: string;
  correspondentBank?: string;
  bankAddress?: string;
  currency: Currency;
  balance?: number;
  companyId: string;
  createdAt: string;
  updatedAt: string;
}

export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  CNY = 'CNY',
  GBP = 'GBP',
  CAD = 'CAD',
  PLN = 'PLN'
}

export interface CreateCompanyRequest {
  name: string;
  taxId: string;
  vatId?: string;
  country?: string;
  city?: string;
  address?: string;
  phone?: string;
  email?: string;
  website?: string;
  logoPath?: string;
}

export interface UpdateCompanyRequest extends CreateCompanyRequest {}

export interface CreateBankAccountRequest {
  name: string;
  accountNumber: string;
  bankName: string;
  swift?: string;
  iban?: string;
  correspondentAccount?: string;
  correspondentBank?: string;
  bankAddress?: string;
  currency: Currency;
  balance?: number;
}

export interface UpdateBankAccountRequest {
  name: string;
  accountNumber: string;
  bankName: string;
  swift?: string;
  iban?: string;
  correspondentAccount?: string;
  correspondentBank?: string;
  bankAddress?: string;
  currency: Currency;
  balance?: number;
}
